<template lang="pug">
    div.store-slider-control(v-show="show")
        profile-files-container-control(title="Store" @defaultAction="goToStorePage")
            media-list-control.store-slider-control__list(:media="media" mode="slider" :squareAspect="true" :itemClickCallback="goToProductPage")
                template(v-slot:decorate-item="{ mediaItem }")
                    div.store-slider-control__info
                        div.store-slider-control__info-description
                            fit-truncate-text-control {{ mediaItem.product.title }}
                        div.store-slider-control__info-price ${{ mediaItem.product.price }}
</template>

<script>
import UserProductsService from '../../services/user-products-service'

export default {
    name: 'store-slider-control',

    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            products: [],
        }
    },

    computed: {
        show() {
            return this.products.length > 0
        },

        media() {
            return this.products.map(p => ({
                ...p.images.data[0],
                product: p,
            }))
        },
    },

    methods: {
        async load() {
            this.products = await UserProductsService.byType(this.user.id, 'creator', 'desc')
        },

        goToProductPage(mediaItem) {
            this.$router.push({
                name: 'store-product-page',
                params: {
                    username: this.user.username,
                    productId: mediaItem.product.id,
                },
            })
        },

        goToStorePage() {
            this.$router.push({ name: 'store-page', params: { username: this.user.username }})
        },
    },

    created() {
        this.load()
    },
}
</script>
